import React from 'react';

import Grid from 'components/Grid';

import InfoItem from '../components/InfoItem';

const ServerInfo = ({ server }) => {
  if (!server) return null;

  return (
    <Grid gutter={[24, 24]} columns={2}>
      <InfoItem name="Model" value={server.model} />
      <InfoItem name="Location" value={server.location_name} />
      <InfoItem name="CPU" value={server.cpu} />
      <InfoItem name="GPU" value={server.gpu} />
      <InfoItem name="Ram" value={server.ram} />
      <InfoItem name="HDD" value={server.hdd} />
      <InfoItem name="App Version" value={server.app_version} />
    </Grid>
  );
};

export default ServerInfo;
